import React from 'react';
import { Redirect } from 'react-router-dom';
import urlencode from 'urlencode';

// local dependencies
import { messageBus as MessageBus } from 'core/modules/message-bus';
import { EVENT_HTTP_AUTH_ERROR  } from 'core/constants/message-bus-events';
import * as sessionManager from 'utils/sessionManager';
import * as ROUTE_PATHS from 'constants/route-paths';
import { temporaryLoginStage as TemporaryLoginStage } from 'ui/views/layouts/temporaryLoginStage';

/**
 * @type {function}
 * @desc A Higher-Order-Component to enhance functionality of `Component`
 * @param {object} Component - A React component
 * @example
 * import { checkIfLoggedIn, CheckIfLoggedIn } from 'ui/hoc/checkIfLoggedIn';
 * import { testView as TestView } from 'views/Test.view';
 *
 * // create a component
 * const ComponentWithHOC = CheckIfLoggedIn( TestView );
 * @return {class} - A standard React component
 */
const checkIfLoggedIn = ( Component, routeConfig = {} ) => {
    class CheckIfLoggedIn extends React.Component {
        constructor( props ) {
			super( props );
			log.debug( 'checkIfLoggedInHoc.constructor()' );

			// listen to HTTP auth message bus event
            MessageBus.on( EVENT_HTTP_AUTH_ERROR, this.handleAuthError, this );

		}

		/**
         * @desc Listen to HTTP unauthentication error
         */
        handleAuthError( { statusCode } ) {
            log.debug( 'checkIfLoggedInHoc.handleAuthError()' );

            //when user is unauthenticated, clear localstorage and redirect to error page
            if( 401 === statusCode || 403 === statusCode ) {
                sessionManager.clearUserSessionData( () => {

					if( routeConfig.isLoginScreen ) {
						this.props.history.replace( this.props.location.pathname );
					} else {
                        
                        //this.props.history.replace( ROUTE_PATHS.UNAUTHENTICATED );
                        window.location.href = ROUTE_PATHS.SAML_LOGIN;
                        
					}
                } );
            }
		}

		/**
         * @desc When component unmounts, remove message bus event listeners
         */
        componentWillUnmount() {
			log.debug( 'checkIfLoggedInHoc.componentWillUnmount()' );

            MessageBus.off( EVENT_HTTP_AUTH_ERROR, this.handleAuthError, this );
        }

        render() {
            log.debug( 'checkIfLoggedInHoc.render()' );


            // get logged in state from local storage
			const isUserLoggedIn = sessionManager.isUserLoggedIn();

            // create redirect url
			const redirectUrl = urlencode( this.props.location.pathname + this.props.location.search );

            /**
             * if current screen is login screen => if user is logged in then redirect to home else render login component
             * otherwise => if user is logged in, render the component else rediect to login screen
             */
            if( routeConfig.isLoginScreen ) {

				if( undefined === isUserLoggedIn ) {
					return <TemporaryLoginStage redirectUrl = { redirectUrl } { ...this.props } />;
				} else {
					return (
						isUserLoggedIn ? <Redirect to={ { pathname: ROUTE_PATHS.DASHBOARD } } /> : <Component { ...this.props }/>
					);
				}

            } else {
				if( false === isUserLoggedIn ) {
					return (
						<Redirect to={ { pathname: ROUTE_PATHS.DASHBOARD, search: `?redirect=${ redirectUrl }` } } />
					);
				} else {
					return (
						<Component { ...this.props }/>
					);
				}
            }
        }
    }

    // set display name
    CheckIfLoggedIn.displayName = 'CheckIfLoggedIn';

    // set default props
    CheckIfLoggedIn.defaultProps = {};

    // return class
    return CheckIfLoggedIn;
};

export { checkIfLoggedIn };
